import PollBasicModel from "./PollBasicModel";
import PollOptionModel from "./PollOptionModel";
import PollVoteBasicModel from "./PollVoteBasicModel";
import PreviousPollVoteModel from "./PreviousPollVoteModel";

export default class PollVoteFullModel extends PollVoteBasicModel {
  public pollModel: PollBasicModel = null;
  public optionModel: PollOptionModel = null;
  public optionsModels: PollOptionModel[] = [];
  public previousVotes: PreviousPollVoteModel[] = [];
  public attempts: number | null = null;
}
